import React, { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import "../MoComponents/MoComponent.css";
import { CommonContext } from "../../context/CommonContext";
import { authHttp } from "../../services/commonHttpService";
import { apisPath } from "../../utils/path";
import BookAppointmentModal from "../MoComponents/BookAppointmentModal/BookAppointmentModal";
import { AuthContext } from "../../context/AuthContext";
import ChemotherapyProgress from "./ChemotherapyProgress"; 
import AppointmentSlots from "./AppointmentSlots";

const AppointmentSlotsCard = (props) => {
  const { userRole } = useContext(AuthContext);
  const { patientId, planned_chemo_cycles, patientName, handleInitiateTreatment } = props;
  const { setIsLoading, setAlertState } = useContext(CommonContext);
  const [appointmentData, setAppointmentData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Fetch dashboard data
  const fetchAppointmentData = async () => {
    setIsLoading(true);
    try {
      const response = await authHttp.get(
        `${apisPath?.getAllChemoSessions}/${patientId}`
      );

      if (response?.data) {
        const counts = response?.data?.data;
        setAppointmentData(counts);
      }
    } catch (error) {
      // setAlertState((prev) => ({
      //   ...prev,
      //   open: true,
      //   title: error?.response?.data?.message,
      //   btnTxt: "CLOSE",
      //   status: "fail",
      // }));
    } finally {
      setIsLoading(false);
    }
  };

  // Delete appointment session - actual deletion logic
  const performDelete = async (allotment_id, patient_id, slot_id) => {
    setIsLoading(true);
    try {
      const payload = {
        allotment_id,
        patient_id,
        slot_id,
      };

      const response = await authHttp.post(
        apisPath?.deleteChemoSessions,
        payload
      );

      if (response?.data?.status) {
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: response?.data?.message || "Appointment cancelled successfully",
          btnTxt: "CLOSE",
          status: "success",
          type: "alert",
        }));

        // Refresh appointment data after successful deletion
        fetchAppointmentData();
      }
    } catch (error) {
      setAlertState((prev) => ({
        ...prev,
        open: true,
        title: error?.response?.data?.message || "Failed to cancel appointment",
        btnTxt: "CLOSE",
        status: "fail",
        type: "alert",
      }));
    } finally {
      setIsLoading(false);
    }
  };

  // Handle delete session with confirmation
  const handleDeleteSession = (allotment_id, patient_id, slot_id) => {
    setAlertState((prev) => ({
      ...prev,
      open: true,
      // title: "Confirm Deletion",
      message: "Are you sure you want to delete this appointment session?",
      btnTxt: "Yes",
      cancelBtnTxt: "No",
      status: "warning",
      type: "confirm",
      onConfirm: () => {
        performDelete(allotment_id, patient_id, slot_id);
      },
      onClose: null,
    }));
  };

  // Handle Add More Sessions button click
  const handleAddMoreSessions = () => {
    // Count all sessions (regardless of is_Deleted status)
    const totalSessionsCount = appointmentData.length;

    // Check if total sessions count is already equal to or exceeds planned cycles
    if (totalSessionsCount >= planned_chemo_cycles) {
      setAlertState((prev) => ({
        ...prev,
        open: true,
        // title: "Maximum Sessions Reached",
        message: "You have booked all the sessions suggested by TCCC. Do you still want to add more chemo sessions?",
        btnTxt: "Yes",
        cancelBtnTxt: "No",
        status: "info",
        type: "confirm",
        onConfirm: () => {
          setIsModalOpen(true);
        },
        onClose: null,
      }));
    } else {
      // Directly open the modal if under the limit
      setIsModalOpen(true);
    }
  };

  // Handle modal close
  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  // Handle successful booking
  const handleBookingSuccess = () => {
    setIsModalOpen(false);
    // Refresh appointment data after successful booking
    fetchAppointmentData();
  };

  // Calculate progress statistics
  const calculateProgressStats = () => {
    const totalSlots = planned_chemo_cycles;
    const completed = appointmentData.filter(
      (slot) => slot?.treatment_status === 1
    ).length;
    const pending = totalSlots - completed;
    const progress = totalSlots > 0
      ? Math.round((completed / totalSlots) * 100)
      : 0;
    const remaining = totalSlots - completed;

    return {
      totalSlots,
      completed,
      pending,
      progress,
      remaining: remaining > 0 ? remaining : 0,
    };
  };

  // Fetch dashboard data on component mount
  useEffect(() => {
    fetchAppointmentData();
  }, [patientId]);

  const progressStats = calculateProgressStats();

  return (
    <>
      <Box className="col-md-4 col-12 mb-3 mb-md-0">
        <ChemotherapyProgress
          progressStats={progressStats}
          totalCycles={planned_chemo_cycles}
        />
      </Box>
      <Box className="col-md-5 col-12 mb-3 mb-md-0">
        <AppointmentSlots
          appointmentData={appointmentData}
          userRole={userRole}
          onDeleteSession={handleDeleteSession}
          onAddMoreSessions={handleAddMoreSessions}
          handleInitiateTreatment={handleInitiateTreatment}
        />
      </Box>

      {/* Book Appointment Modal */}
      <BookAppointmentModal
        open={isModalOpen}
        onClose={handleModalClose}
        patientId={patientId}
        patientName={patientName}
        onSuccess={handleBookingSuccess}
        planned_chemo_cycles={planned_chemo_cycles}
        existingSessionsCount={appointmentData.length}
      />
    </>
  );
};

export default AppointmentSlotsCard;
